import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation TimeSeriesSettingsPage_DeleteSurveyGroup($surveyGroupId: String!) {
    deleteSurveyGroup(surveyGroupId: $surveyGroupId) {
      result
    }
  }
`)

export const useDeleteSurveyGroupMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, string, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (surveyGroupId) =>
      graphQLRequest({
        document,
        variables: { surveyGroupId },
      }),
    ...options,
  })
}
